import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFavoriteMarketsGoodsParams,
  GetFavoriteMarketsGoodsResponse,
} from './types';

/**
 * - 즐겨찾는 마켓의 상품 리스트 (정렬/카테고리 필터 + pagination)
 */
export const getFavoriteMarketsGoods = async ({
  order,
  category_sno,
  last_sno,
}: GetFavoriteMarketsGoodsParams = {}) => {
  return defaultHttpClient
    .request<GetFavoriteMarketsGoodsResponse>({
      method: 'GET',
      url: '/api/v2/favorite-markets/goods/',
      params: { order, category_sno, last_sno },
    })
    .then(result => result.data);
};
